import React, { useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { safeNext } from './safeNext';
import { ArrowRight } from 'lucide-react';
import SubpageShell from '../pages/SubpageShell';
import SEO from '../components/SEO';
import { useMember, formatApiError } from './MemberAuthContext';
import '../styles/Access.css';
import '../styles/AccessAuth.css';

const MemberLogin = () => {
  const { login } = useMember();
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await login(email.trim().toLowerCase(), password);
      const to = next || location.state?.from || '/access/account';
      navigate(to, { replace: true });
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail, 'Could not sign in. Please try again.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SubpageShell currentPath="/access/sign-in">
      <SEO title="Sign in — N3URO Access" description="Sign in to your N3URO Access account." path="/access/sign-in" noindex />
      <section className="access-auth-band">
        <div className="access-auth-card" data-testid="member-signin-card">
          <h1 className="access-auth-title">Sign in to <span className="access-brand-rainbow">N3URO ACCESS</span></h1>
          <p className="access-auth-lede">Welcome back — your journeys, passport and saved places are ready.</p>
          <form onSubmit={submit} className="access-signup-form" noValidate>
            <input className="access-input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signin-email" autoComplete="email" />
            <input className="access-input" type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signin-password" autoComplete="current-password" />
            {error && <p className="access-auth-error" data-testid="signin-error">{error}</p>}
            <button type="submit" className="access-signup-cta" disabled={busy} data-testid="signin-submit">
              {busy ? 'SIGNING IN…' : (<>SIGN IN <ArrowRight size={16} /></>)}
            </button>
          </form>
          <div className="access-auth-links">
            <Link to="/access/forgot-password" data-testid="signin-forgot">Forgot your password?</Link>
            <span aria-hidden="true">·</span>
            <Link to={next ? `/access/join?next=${encodeURIComponent(next)}` : '/access/join'} data-testid="signin-join">Create a Free Access account</Link>
          </div>
        </div>
      </section>
    </SubpageShell>
  );
};

export default MemberLogin;
